// extracted by mini-css-extract-plugin
module.exports = {"titleSection":"VideosTableList_titleSection_3vSgN","toggle":"VideosTableList_toggle_X4WJl","hideIcon":"VideosTableList_hideIcon_1-p4w"};